import { SequenceNode } from "../../../../../libs/ts/WorkflowTree/Nodes/SequenceNode";
import { Model } from "../Model";
import { JbpTreeNodeData } from "../treeExtensions/JbpTreeNodeData";
import { FieldType, ITagGroup } from "../treeExtensions/FieldInterfaces";
import { IJbpChildNodeRelationship } from "../treeExtensions/IJbpChildNodeRelationship";

const captureExtraSkillsPrependedMessagePath = "model.jobCommentPrependedMessages.extraSkills";


export class CaptureExtraSkills extends SequenceNode<JbpTreeNodeData, IJbpChildNodeRelationship> {
    constructor() {
        super("captureExtraSkills", new JbpTreeNodeData("Please select any required extra skills", [
            {
                fieldType: FieldType.TagGroup,
                modelPath: "model.results.extraSkills",
                hideTitle: true,
                isValid: (_value: string[]) => {
                    return { isValid: true }
                },
                onChange: (value: string[]) => {
                    if(value?.length > 0) {
                        Model.GetModel().Set(captureExtraSkillsPrependedMessagePath, `Extra Skills: ${value.toString()}\n`)
                    }
                    else {
                        Model.GetModel().Set(captureExtraSkillsPrependedMessagePath, ``)
                    }
                },
                tags: [
                    {
                        tagId: "4x4"
                    }
                ]

            } as ITagGroup
        ]))
    }
}
